module.exports = __webpack_public_path__ + "img/choose-up-Up Vacanta.83ea4bb9.png";